import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Login from '../auth/Login';
import Register from '../auth/Register';
import Home from '../pages/Home';
import PrivateRoute from './PrivateRoute';
import Profile from '../pages/Profile';
import Address from '../pages/Address';
import Booking from '../pages/Booking';
import ServiceHistory from '../pages/ServiceHistory';
import Invoice from '../components/Invoice';
import Feedback from '../components/Feedback';
import Support from '../pages/Support';
import UpcomingService from '../components/UpcomingService';
import More from '../components/More';
import PasswordRest from '../pages/PasswordRest';
import LiveChat from '../components/LiveChat';
import ResetPassword from '../pages/ResetPassword';

export default function PageNavigation() {
	return (
		<Routes>
			<Route path="/" element={<Login />} />
			<Route path="/register" element={<Register />} />
			<Route path="/feed-back" element={<Feedback />} />
			<Route path="/support" element={<LiveChat />} />
			<Route path="/reset" element={<ResetPassword />} />

			{/* Protected Route */}
			<Route
				path="/dashboard"
				element={
					<PrivateRoute>
						<Home />
					</PrivateRoute>
				}
			/>
			<Route
				path="/profile"
				element={
					<PrivateRoute>
						<Profile />
					</PrivateRoute>
				}
			/>
			<Route
				path="/your-address"
				element={
					<PrivateRoute>
						<Address />
					</PrivateRoute>
				}
			/>
			<Route
				path="/book-repair"
				element={
					<PrivateRoute>
						<Booking />
					</PrivateRoute>
				}
			/>
			<Route
				path="/service-history"
				element={
					<PrivateRoute>
						<ServiceHistory />
					</PrivateRoute>
				}
			/>

			<Route
				path="/more"
				element={
					<PrivateRoute>
						<More />
					</PrivateRoute>
				}
			/>

			<Route
				path="/invoice/:orderNumber"
				element={
					<PrivateRoute>
						<Invoice />
					</PrivateRoute>
				}
			/>
			<Route
				path="/upcoming-service"
				element={
					<PrivateRoute>
						<UpcomingService />
					</PrivateRoute>
				}
			/>
			<Route
				path="/password-reset"
				element={
					<PrivateRoute>
						<PasswordRest />
					</PrivateRoute>
				}
			/>
		</Routes>
	);
}
